import React from 'react';
import { Tooltip } from './tooltip.component';
import './color-picker.style.scss';

export interface ColorPickerProps {
  label: string;
  /** One-line explanation of what this color controls, shown in the info tooltip. */
  description?: string;
  value: string;
  onChange: (hex: string) => void;
}

/**
 * An icon-sized swatch button (click to open the native color picker) plus a small
 * info icon carrying the same styled `Tooltip` used throughout the app (see
 * `FormField`) - so a whole palette fits in one compact row while still explaining
 * what each color changes.
 */
export const ColorPicker: React.FC<ColorPickerProps> = ({ label, description, value, onChange }) => {
  return (
    <div className="color-picker">
      <input
        type="color"
        className="color-picker__swatch"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        aria-label={label}
        title={label}
      />
      {description && (
        <Tooltip content={`${label}: ${description}`} position="top">
          <svg
            className="color-picker__info-icon"
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            viewBox="0 0 14 14"
            fill="none"
          >
            <path
              d="M6.7002 9.10508V6.10508M6.7002 4.30508V4.29908M12.7002 6.69922C12.7002 10.0129 10.0139 12.6992 6.7002 12.6992C3.38649 12.6992 0.700195 10.0129 0.700195 6.69922C0.700195 3.38551 3.38649 0.699219 6.7002 0.699219C10.0139 0.699219 12.7002 3.38551 12.7002 6.69922Z"
              stroke="#6750B8"
              strokeWidth="1.4"
              strokeLinecap="round"
            />
          </svg>
        </Tooltip>
      )}
    </div>
  );
};
